import React from "react";
import Navbar from "../widgets/Navbar";
import Footer from "../widgets/Footer";

const Awards = () => {
  return (
    <div>
      <Navbar />
       <section className="in_page p70 bg4 pb-0">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-7 ">
              <h1 className="hadding">Awards</h1>
              <p>
                Dyntech’s commitment to innovation and customer success has been recognized by leading industry bodies. Below are our most recent accolades:

              </p>
            </div>
            <div className="col-md-4 m-auto col-8">
              <img
                src="/img/awards.png"
                alt="awards"
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </section>
       <section className="in_page p70">
        <div className="container"> 
              <h2 className="hadding">2024</h2>
              <h3>Best White Label Provider</h3>
              <p>Awarded as the Best White Label Provider, Dyntech has set a new benchmark in delivering innovative solutions for businesses. This recognition celebrates their expertise in providing top-notch white label services, empowering partners to thrive.    </p> 
             <h2 className="hadding mt-md-5 mt-4">Our Philosophy</h2> 
              <p>Every award fuels our drive to continuously improve. We don’t just build software -we push the boundaries of what’s possible in financial technology.  </p> 
               <p>Discover how our award-winning solutions can transform your business. Get in Touch</p>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Awards;
